import { Grid, Typography, Tooltip, Divider } from "@mui/material";
import React from "react";
import { useTheme } from "@mui/material/styles";
import LeaveWageGrid from "./LeaveWage/LeaveWageGrid";
import TransportAllowanceGrid from "./TransportAllowance/TransportAllowanceGrid";
import PHAllowanceGrid from "./PHAllowance/PHAllowanceGrid";
import OverTimeGrid from "../OverTime/OverTimeGrid";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import FoodAllowanceGrid from "./FoodAllowance/FoodAllowanceGrid";
import AdjustmentComponentsGrid from "../AdjustmentComponents/AdjustmentCompGrid";
import { ComponentConfig } from "../ComponentConfig/ComponentConfig";
import StatutoryBonusGrid from "./StatutoryBonus/StatutoryBonusGrid";
  
const tooltipMessages = {
  "Leave Wages":
    "Calculated from earnings and attendance using a company-defined multiplier (e.g. 26/20) to reflect statutory leave entitlement.",
  "Transport Allowance":
    "It compensates for travel expenses and can be configured as either a fixed monthly amount or a variable daily rate.",
  "PH Wages":
    "It is paid to employees who work on public holidays. It can be configured as a fixed amount or linked to earnings.",
  "Bonus":
    "Bonus based on employee earnings, with eligibility and calculation rules defined by the company.",
  "Food Allowance":
    "Food-based earning or deduction. Supports fixed or daily-amount calculations with eligibility rules.",
  "PayEntry Components": "Manual payroll adjustments won’t be part of prorated calculations. You can configure them per employee and month under Payroll > Post Adjustment.",
  "Overtime": "Overtime is configured using unique OT codes and can be set as either flat or variable. These codes can then be assigned to employees as part of their payroll configuration."
};

const TemplateCompLandingPage = () => {
  const theme = useTheme();
  const values = [
      { name: "Earning Components", comp: <ComponentConfig type='Earning'/> },
      { name: "Deduction Components", comp: <ComponentConfig type='Deduction'/> },
      { name: "Transport Allowance", comp: <TransportAllowanceGrid /> },
      { name: "Food Allowance", comp: <FoodAllowanceGrid /> },
      { name: "Leave Wages", comp: <LeaveWageGrid /> },
      { name: "PH Wages", comp: <PHAllowanceGrid /> },
      { name: "Bonus", comp: <StatutoryBonusGrid /> },
      { name: "PayEntry Components", comp: <AdjustmentComponentsGrid /> },
      { name: "Overtime", comp: <OverTimeGrid /> },
  ];

  return (
    <Grid container spacing={2} style={{ padding: "10px 0px" }}>
      {values?.map((value, id) => (
        <React.Fragment key={id}>
          <Grid
            item
            xs={12}
            md={
              ["Transport Allowance", "Food Allowance"].includes(value?.name)
                ? 6
                : 12
            }
          >
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                paddingLeft: "15px",
                color: theme.palette.primary.contrastText,
              }}
            >
              {value.name}
              {tooltipMessages[value.name] && (
                <Tooltip
                  title={tooltipMessages[value.name]}
                  placement="right"
                  arrow
                >
                  <InfoOutlinedIcon
                    fontSize="small"
                    color="action"
                    sx={{ ml: 1, verticalAlign: "middle", cursor: "pointer" }}
                  />
                </Tooltip>
              )}
            </Typography>
            {value?.comp}
          </Grid>
          {([0, 1, 3, 4, 5, 6, 7, 8].includes(id)) && (
              <Grid item xs={12}>
                  <Divider sx={{ my: 1 }} />
                  {id === 1 && (<Typography
                    variant="h5"
                    // gutterBottom
                    sx={{
                      paddingLeft: "15px",
                      color: theme.palette.primary.contrastText,
                    }}
                  >
                    Standard Calculation Configuration
                  </Typography>)}
              </Grid>
          )}
        </React.Fragment>
      ))}
    </Grid>
  );
};

export default TemplateCompLandingPage;
